

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


	var Main = function( )
	{
		var _this = this , i ;

		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// この中に処理を書いていってください。

		// モーダル
		var remodalOptions = {
			'appendTo' : $("#js-slide-modal"),
			'hashTracking' : false // hashTracking を true にすると Remodal の opened イベントが2回実行されてしまう。バグ？
		}
		var remodalInst = $('[data-remodal-id=manga]').remodal(remodalOptions);

		// スライダー
		var startSlideNum = 2;
		var slickOptions = {
			'initialSlide' : startSlideNum,
			'infinite' : false,
			'prevArrow' : $('.manga_slide__nav .nav__prev'),
			'nextArrow' : $('.manga_slide__nav .nav__next')
		}
		var slickInst = $('.manga_slides');

		if(location.hash === "#manga"){
			remodalInst.open();
			slickInst.slick(slickOptions);
			getPagerText(startSlideNum);
		}

		$(document).on('opened', '.remodal', function () {
			slickInst.slick(slickOptions);
			getPagerText(startSlideNum);
		}).on('closed', '.remodal', function () {
			getPagerText(startSlideNum);
			slickInst.slick('unslick');
		});

		// On before slide change
		slickInst.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			getPagerText(nextSlide);
		});

		function getPagerText(index) {
			var ttl = $('.manga_slides .manga_slide__item').eq(index).attr('data-title');
			$('.slide-title').text(ttl);

			var prev = $('.manga_slides .manga_slide__item').eq(index).attr('data-prev-text');
			$('.nav__prev > a').text(prev);

			var next = $('.manga_slides .manga_slide__item').eq(index).attr('data-next-text');
			$('.nav__next > a').text(next);
		}

		// ページ読み込み後にFitContentsのサイズをリセット => IE11 対策（フッター下に大きな余白が空いてしまう）
		addEventListener('load', function(){
			setTimeout(function(){
				FitContents.onResize();
				FitContents.fit();
			},100);
		});

		// UA 判別は Fit の method を拝借
		var isSP = Fit.isSP;

		// iPad 判別
		function ipad_ua() {
			var ua = navigator.userAgent
			if(ua.indexOf("iPad")>0) {
				return true;
			} else {
				return false;
			}
		}
		// Android 判別
		function android_ua() {
			var ua = navigator.userAgent
			if(ua.indexOf("Android")>0) {
				return true;
			} else {
				return false;
			}
		}

		var isiPad = ipad_ua();
		var isAndroid = android_ua();

		if(isiPad || isAndroid) {
			$('body').addClass('is-iPad');
		}

		// TOP
		if($('body.is-top').get(0)) {
			$('.js-ticker .ticker-text').each(function(){
				var clone = $(this).find('p').clone();
				$(this).append(clone.clone());
				$('.top-mv__ticker-pc .ticker-text').append(clone.clone())
					.append(clone.clone())
					.append(clone);
			});

			// CreateJS によるキラキラ
			stage = new createjs.Stage('js-glitter-pc');
			particleSystem = new particlejs.ParticleSystem();
			stage.addChild(particleSystem.container);
			particleSystem.importFromJson(particle_value_pc);
			createjs.Ticker.framerate = 60;
			createjs.Ticker.on("tick", handleTick);
			function handleTick() {
				particleSystem.update();
				stage.update();
			}

			if(!isSP || isiPad) {
				// PC処理

				// 背景動画
				var elm = $('<video />').attr({
					src    : '/promotion/4th_anniversary/assets/index/mov/top-mv.min.mp4',
					poster : '/promotion/4th_anniversary/assets/index/img/pc/mv-poster.jpg'
				});
				elm[0].autoplay = true;
				elm[0].loop = true;
				$('.js-video-insert').append(elm);
			}

			if(!isSP) {
				// PC処理

				// hover 処理
				$('.top-mv__nav-list .list-item > a').each(function(){
					$(this).hover(function(){
						$(this).closest('.list-item').addClass('hover');
					}, function(){
						$(this).closest('.list-item').removeClass('hover');
					});
				});

				// ウィンドウ高さ取得 → MVの高さ設定
				var winHeight = window.innerHeight;
				$('.top-mv, .top-mv-inner').css('height', (winHeight - 75) + 'px');

				// SP 用のスクロール関係で使用する Class を外す。（外さないとPCをでウィンドウ縮めたら真っ黒）
				$('.top-mv').removeClass('is-ready');

			} else {
				// SP処理

				// cookie
				var mode = GetCookie('sp_4th_anniversary');
				var param = getParameter('demo');
				if(param === '1') {
					mode = '';
				}
				// console.log('cookie:' + GetCookie('sp_4th_anniversary') + ' mode:' + getParameter('demo'));

				if(mode !== 'visited' && location.hash !== "#manga") {
					$('.btn-speaker').show();
					$('.intro-wrapper').show();

					// BGM
					var bgm = $('<audio />').attr({
						src    : '/promotion/4th_anniversary/assets/index/audio/bgm.mp3'
					});
					bgm[0].loop = true;
					bgm[0].volume = 0.5;
					$('.js-audio-insert').append(bgm);
					bgm.ready(function() {
						$('.btn-speaker').on('click', function(){
							if(bgm[0].paused) {
								bgm[0].play();
								$('.btn-speaker').addClass('is-playing');
							} else {
								bgm[0].pause();
								$('.btn-speaker').removeClass('is-playing');
							}
						});
					});

					// イントロ

					// スクロールさせない
					var no_scroll = function() {
						var _this = this;
						var scrollOff = function(e){
							e.preventDefault();
						}
						no_scroll.set = function(e) {
							window.addEventListener( 'touchmove' , scrollOff ,{
								passive: false
							}) ;
						};
						no_scroll.unset = function(e) {
							window.removeEventListener( 'touchmove' , scrollOff ,{
								passive: false
							}) ;
						};
					};
					no_scroll();
					no_scroll.set();

					// アニメーション
					var timeLine = new TimelineMax();

					timeLine.to('.intro-c02-layer' , .5 , {
						opacity : 1 , // CSSのプロパティ(+=とかも使えます)
						delay : 1 , // 実行までの待ち時間です
						ease : 'Linear' , // イージングです。後述しますがTweenMax独自のイージングもあります。
					})
					.to('.intro-c02-layer' , .5 , {
						opacity : 0 ,
						delay : 2 ,
						ease : 'Linear'
					})
					.to('.intro-c03-layer' , .8 , {
						opacity : 1 ,
						delay : 1 ,
						ease : 'easeIn'
					})
					.to('.intro-c03-letter-close' , .5 , {
						opacity : 1 ,
						'margin-top': -200,
						delay : 0 ,
						ease : 'easeOut',
						onComplete: function(){
							TweenMax.to('.intro-c03-letter-close' , 0.1 , {
								opacity : 0 ,
								delay : 0 ,
								ease : 'Linear'
							})
						}
					})
					.to('.intro-c03-letter-open' , .5 , {
						opacity : 1 ,
						delay : 0 ,
						ease : 'Linear'
					})
					.to('.intro-c03-letter-invite' , 1.5 , {
						opacity : 1 ,
						'margin-top': -200,
						delay : 0 ,
						ease : 'easeIn'
					})
					.set('.intro-c03-letter-open', { opacity : 0 })
					.set('.intro-c03-letter-close', { opacity : 0 })
					.set('.intro-c01-layer', { opacity : 0 })
					.set('.intro-c02-layer', { opacity : 0 })
					.set('.goto-and-play', { 'pointer-events' : 'all' })
					.set('.goto-top', { 'pointer-events' : 'all' });

					$('.goto-and-play').on('click', function(){

						$('.top-mv').removeClass('is-ready');
						$('.btn-speaker').css('pointer-events','none');

						timeLine.to('.intro-c03-letter-invite' , 1.5 , {
							opacity : 0 ,
							'margin-top': -1200,
							delay : 0.5 ,
							ease: Power3.easeIn
						})


						TweenMax.to('.intro-c03-layer' , 1 , {
							opacity : 0 ,
							delay : 1 ,
							ease : 'Linear'
						})
						TweenMax.to('.intro-c04-curtain-left' , 3.75 , {
							opacity : 1 ,
							'margin-left': -200,
							delay : 1 ,
							ease : Power3.easeOut
						})
						TweenMax.to('.intro-c04-curtain-right' , 4 , {
							opacity : 1 ,
							'margin-left': 200,
							delay : 1 ,
							ease : Power3.easeOut,
							onComplete: function() {
								$('.intro-wrapper').hide();
							}
						});
						if(bgm.get(0)) {
							TweenMax.to('.btn-speaker' , 4 , {
								opacity : 0 ,
								delay : 0 ,
								ease : 'Linear',
								onComplete: function() {
									$('.btn-speaker').hide();
									bgm[0].pause();
								}
							});
						}

						FitContents.onResize();
						FitContents.fit();

						// スクロールを許可
						no_scroll.unset();

					});
				} else {
					$('.top-mv').removeClass('is-ready');

				}

				// cookie 保存
				var expire = new Date();
				expire.setTime( expire.getTime() + 1000 * 3600 * 24 );
				document.cookie = 'sp_4th_anniversary=visited; expires=' + expire.toUTCString();

				// 背景動画（代替画像の設置）
				var elm = $('<img />').attr({
					src : '/promotion/4th_anniversary/assets/index/img/pc/mv-poster.jpg'
				});
				$('.js-video-insert').append(elm);

			}

			// スクロールイベント
			var scrollItem = $('[data-margin-scale]');
			scrollItem.each(function(i){
				var target = $(this);
				var margin = Number(target.attr('data-margin-scale'));
				ScrollEnterEvent.add(target, {
					onEnter: function() {
						target.addClass('is-active');
					},
					marginScale: margin
				});
			});

			function getParameter(key) {
				var str = location.search.split("?");
				if (str.length < 2) {
					return "";
				}
				var params = str[1].split("&");
				for (var i = 0; i < params.length; i++) {
					var keyVal = params[i].split("=");
					if (keyVal[0] == key && keyVal.length == 2) {
						return decodeURIComponent(keyVal[1]);
					}
				}
				return "";
			}

			function GetCookie( name ) {
				var result = null;

				var cookieName = name + '=';
				var allcookies = document.cookie;

				var position = allcookies.indexOf( cookieName );
				if( position != -1 ) {
					var startIndex = position + cookieName.length;

					var endIndex = allcookies.indexOf( ';', startIndex );
					if( endIndex == -1 ) {
						endIndex = allcookies.length;
					}

					result = decodeURIComponent(
						allcookies.substring( startIndex, endIndex ) );
					}
				return result;
			}

		}

		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// リサイズイベントを使うときは、この_onResize内に処理を書いてください。
		// リサイズイベントを綱わないようでしたら決してください。
		// var _onResize = function( )
		// {

		// }

		// _onResize( ) ;
		// FitContents.addTask( _onResize ) ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;

var particle_value_pc = {
    "bgColor": "#FFFFFF",
    "width": 1058,
    "height": 184,
    "emitFrequency": 7,
    "startX": 541,
    "startXVariance": 866,
    "startY": 88,
    "startYVariance": 125,
    "initialDirection": 0,
    "initialDirectionVariance": 0,
    "initialSpeed": 0,
    "initialSpeedVariance": 0,
    "friction": 0,
    "accelerationSpeed": 0,
    "accelerationDirection": 0,
    "startScale": 0.57,
    "startScaleVariance": 0.09,
    "finishScale": 0.45,
    "finishScaleVariance": 0.15,
    "lifeSpan": 213,
    "lifeSpanVariance": 173,
    "startAlpha": 0.81,
    "startAlphaVariance": "0",
    "finishAlpha": "0",
    "finishAlphaVariance": "0",
    "shapeIdList": [
        "blur_circle",
        "kirakira"
    ],
    "startColor": {
        "hue": 0,
        "hueVariance": 0,
        "saturation": 0,
        "saturationVariance": 0,
        "luminance": 85,
        "luminanceVariance": 63
    },
    "blendMode": true,
    "alphaCurveType": "0",
    "VERSION": "1.0.0"
}
